module.exports = {
    trackEvent: (eventName, payload) => {
        if (typeof MixpanelWrapper === 'undefined') {return;}
        MixpanelWrapper.trackEvent(
            eventName,
            payload
        );
    }
};